
(function (Drupal) {
  'use strict';


  // Gallery Slider
  Drupal.behaviors.gallerySlider = {

    initialized: false,

    attach: function (context) {
      if(!this.initialized){
        this.initialized = true;
        this.init(context);
      }
    },

    init: function(context) {
      // Grab all galleries
      var galleries = document.querySelectorAll(".js-gallery");

      galleries.forEach(function(gallery) {

        var galleryMain = gallery.querySelector('.glide--gallery');
        var galleryThumbnails = gallery.querySelector('.glide--thumbnail');
        var galleryIndex = gallery.querySelector('.js-gallery-index');

        // Set up the main and thumbnail gallery
        var galleryMainGlide = new Glide(galleryMain, {
          rewind: false,
        });
        var galleryThumbnailsGlide = new Glide(galleryThumbnails, {
          startAt: 0,
          type: 'slider',
          rewind: false,
          perView: 8,
          gap: 24,
          peek: {
            before: 240,
            after: 240
          },
          breakpoints: { 
            1439: {
              peek: {
                before: 150,
                after: 150
              },
            },
            1279: {
              gap: 18,
              perView: 5
            },
            767: {
              perView: 3,
              gap: 16,
              peek: {
                before: 32,
                after: 32
              },
            }
          }
        });


        ///// When you click on a gallery thumbnail, jump to that slide ////
        var galleryButtons = gallery.querySelectorAll('.glide__slide-button');
        galleryButtons.forEach(function(button) {
          button.addEventListener('click', function (e) {
            var index = this.dataset.slideindex;
            galleryThumbnailsGlide.go('=' + index);
          });
        });


        /////// Connect the two glide galleries together so when one changes so does the other ///////
        ////// https://stackoverflow.com/questions/56937018/how-to-synchronize-two-sliders-using-glide-js ////
        galleryMainGlide.on('run', function (e) {
          galleryThumbnailsGlide.go('=' + galleryMainGlide.index);
          galleryIndex.innerHTML = galleryMainGlide.index +1; 
        });
        galleryThumbnailsGlide.on('run', function (e) {
          galleryMainGlide.go('=' + galleryThumbnailsGlide.index);

          // This is to make it so the focus point isnt on the last item,  
          var focusPoint = (galleryThumbnailsGlide.index <= galleryThumbnailsGlide.settings.perView - 1) ? 
          galleryThumbnailsGlide.index
          : galleryThumbnailsGlide.settings.perView - 2;

          galleryThumbnailsGlide.update({focusAt: focusPoint});
        });

        //// Add a Class to the glide to say it mounted correclty ////
        galleryMainGlide.on('mount.after', function() {
          galleryMain.classList.add("glide--active");
        });

        ////// Make only the slides in the Perveiw be visible /////
        galleryThumbnailsGlide.on("move", function () {

          // Get the current slider via glide index. then substract by focus at to make sure all in perview still have full opacity
          // Reason I did not target glid active is because it would grab the wrong active
          var slideStart = gallery.querySelectorAll('.glide__slide:not(.glide__slide--clone)')[galleryThumbnailsGlide.index - galleryThumbnailsGlide.settings.focusAt];
          var perview = galleryThumbnailsGlide.settings.perView; // This Per view will change depending on screen size.

          gallery.querySelectorAll(".glide__slide").forEach(function(glide) {
            glide.classList.remove("glide__slide--visible");
          });
        
          for (var slidIndex = 0; slidIndex < perview; slidIndex++){
            if (slideStart) {
              slideStart.classList.add("glide__slide--visible");
              slideStart = slideStart.nextElementSibling;
            }
          }
        });
     

        // Make sure the gallery only mounts when its visible to the screen
        // This fixes the issue with gallery not showing once modal opens;
        var observer = new IntersectionObserver(function(entries) {
          
          if(entries[0].isIntersecting === true) {

              if(galleryMain){
                galleryMainGlide.mount();
              }
              if(galleryThumbnails){
                galleryThumbnailsGlide.mount();
              }
    
              setTimeout(function() {
                window.dispatchEvent(new Event('resize'));
              }, 5000);
            
          }
        }, { threshold: [0] });
    
        observer.observe(gallery);
      });
    }
  };


}(Drupal));